<div class="details-wrapper">
  <mat-card class="identity wrapper">
    <div *ngIf="dataSource">
      <div class="headline">
        <div class="headline-wrapper">
          <div class="headline-title title">
            <div class="content-wrapper" *ngIf="isCloudBased">
              <div class="row-wrapper row">
                <div class="icon">
                  <logo-widget
                    *ngIf="appImgData.icon"
                    [serviceUrl]="appImgData.url"
                    [defaultUrl]="appImgData.icon"
                    [styleInfo]="'logo-50-wide'"
                  ></logo-widget>
                </div>
                <div class="column">
                  <div class="text title">{{ dataSource.getName() }}</div>
                  <div class="text subtitle">{{ dataSource.getUrl() }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="headline-divider"></div>

          <div class="headline-action-button">
            <div>
              <button
                mat-button
                *ngIf="authorized"
                class="action-button"
                (click)="deleteApplication(dataSource.getId())"
              >
                <mat-icon class="icon" color="primary">delete</mat-icon>
                <span class="action_name">Remove</span>
              </button>
              <button
                mat-button
                *ngIf="authorized"
                class="action-button"
                aria-label="edit application"
                (click)="editApplication()"
              >
                <mat-icon class="icon" color="primary">edit</mat-icon>
                <span class="action_name">Edit</span>
              </button>
              <button
                mat-button
                class="action-button"
                aria-label="edit application"
                (click)="goToSummaryPage()"
              >
                <mat-icon class="icon" color="primary">view_quilt</mat-icon>
                <span class="action_name">View Summary</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="multi-script-container">
        <mat-card class="detail-container">
          <progress-spinner *ngIf="isLoading"> </progress-spinner>
          <div class="app_detail_header">
            <div class="app_name">
              <i class="mdi mdi-script-text-outline"></i>
              <span>Multi-step scripts</span>
            </div>

            <div *ngIf="scriptData.length && authorized && isActWebEnabled" class="button_group">
              <button mat-button class="action-button">
                <i class="mdi mdi-plus"></i
                ><span class="action_name" (click)="openScriptPopup(false)">Add script</span>
              </button>
            </div>
            <span *ngIf="!scriptData.length">
              <span class="script_tutorial"
                >Simulate steps a user would make when using this application
                <a href="#" target="_blank">Visit our script tutorial </a>to learn more</span
              >
            </span>
          </div>
          <div
            class="add_script_button"
            *ngIf="!scriptData.length && authorized && isActWebEnabled"
          >
            <button mat-button (click)="openScriptPopup(false)">
              <i class="mdi mdi-script-text-outline"></i>Add script
            </button>
          </div>
          <div class="script-table-container" *ngIf="table && table.data?.length > 0">
            <viavi-table
              [tableConfigurations]="table"
              [isActionEnabled]="false"
              (sendRowAction)="onActionClick($event)"
              [template]="action"
            >
            </viavi-table>
          </div>
        </mat-card>
      </div>
      <mat-card class="detail-container">
        <div class="app_detail_header">
          <div class="app_name">
            <i class="mdi mdi-test-tube"></i> <span>Where {{ appName }} is being tested</span>
          </div>
          <div class="button_group">
            <button
              mat-button
              [matMenuTriggerFor]="menu"
              class="action-button"
              *ngIf="isUserManageTest"
            >
              <i class="mdi mdi-plus"></i><span class="action_name">Add tests</span>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="addTest('service_test')" class="service_test">
                <i class="material-icons mdi mdi-web"></i> Add Service Tests
              </button>
              <button
                mat-menu-item
                (click)="addTest('multistep_test')"
                class="web_transaction"
                *ngIf="isActWebEnabled"
              >
                <i class="material-icons mdi mdi-script-text-outline"></i>Add Web Transaction Tests
              </button>
            </mat-menu>
            <button
              mat-button
              class="action-button"
              (click)="goToTestListPage()"
              [disabled]="!appTestListData['_value']?.length"
            >
              <i class="mdi mdi-pulse"></i><span class="action_name">View from test list</span>
            </button>
          </div>
        </div>
        <div class="nodata_container" *ngIf="!appTestListData['_value']?.length">
          This application is not being tested
        </div>
        <div class="data_Container" *ngIf="appTestListData['_value']?.length">
          <test-list-table
            [data]="appTestListData"
            [widgetData]="widgetData"
            [layeredSource]="layeredSource"
            [columnHeader]="columnHeader"
            [tableId]="tableId"
          ></test-list-table>
        </div>
      </mat-card>
    </div>
    <div *ngIf="!dataSource">No record found</div>
  </mat-card>
</div>
